export default {
  accounts: [],
  procedures: [],
  filterOptions: {},
  user: {
    name: null,
    email: null,
    token: null,
  },
  filters: {
    home: {
      country: null,
      state: null,
      city: null,
      company: null,
      startDate: null,
      endDate: null,
    },
    procedimento: {
      country: null,
      state: null,
      city: null,
      company: null,
      startDate: null,
      endDate: null,
    },
    contas: {
      country: null,
      state: null,
      city: null,
      company: null,
      startDate: null,
      endDate: null,
    },
  },
};
